<template>
    <div class="annual-leave-dot">
        <div class="annual-leave-dot-background">
            <span class="annual-leave-dot-item" :style="styledColor"></span>
        </div>
        <span class="annual-leave-dot-text">{{ name }}</span>
    </div>
</template>

<script>
import { computed } from "vue";
export default {
    name: "AnnualLeaveDot",
    props: ["name", "color"],
    setup(props) {
        const styledColor = computed(() => `background: ${props.color};`);
        return {
            styledColor,
        };
    },
};
</script>

<style lang="scss">
.annual-leave-dot {
    display: flex;
}
.annual-leave-dot-item {
    height: 10px;
    width: 10px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
}
.annual-leave-dot-text {
    margin: 0 16px 0 6px;
}
</style>
